export default {
      id: "login-rabotaru-usage",
      viewBox: "0 0 19 25",
      url: __webpack_public_path__ + "sprite-46b249.svg#login-rabotaru-usage",
      toString: function () {
        return this.url;
      }
    }